import {AuditService} from "../PA.Core/Security/AuditService";
import {WB_GeneralLedgerPolicyAccountRow} from "../PA.Core/PAdbSchemaRows";
import * as _ from "lodash";
import {GeneralLedgerPolicyBO} from "./GeneralLedgerPolicyBO";
import {auditFieldFK, AuditUtils, IAuditField} from "../PA.Core/Basic/AuditUtils";
import {
    esWB_Customer,
    esWB_Customer_Hierarchy,
    esWB_Event_Spend_Type,
    esWB_Fund_Type,
    esWB_General_Ledger_Account,
    esWB_Product_Group,
    esWB_Product_Hierarchy,
    esWB_Spend_Type
} from "../PA.Core/PAdbSchema";

export class GeneralLedgerPolicyBOAudit {

    // Audit Log Service for General Ledger Policy

    static async GeneralLedgerPolicyAuditBO(GeneralLedgerPolicyBO: GeneralLedgerPolicyBO): Promise<AuditService> {
        const self = GeneralLedgerPolicyBO
        const auditService = new AuditService(self.dbContext)
        auditService.setReference("GeneralLedgerPolicy", self.drWB_GeneralLedgerPolicy.cif.WB_GLRL_ID)
        // @ts-ignore
        self.deleteKeys = self.deleteKeys || {}
        // @ts-ignore
        let deleteKeys: any = self.deleteKeys
            const generalLedgerPolicyParams: IAuditField [] = [
                {fieldName: "GLRULE_ID",            realName: "GL Rule ID", bAllMsg: true},
                {fieldName: "GLRULE_NAME",          realName: "Name",       bAllMsg: true},
                {fieldName: "PRODUCT_OUTPUT_LEVEL", realName: "Product Output Level", domainId: "ProductGroup_Level"},
                {fieldName: "PRODUCT_ALLOCATION_METHOD", realName: "Product Allocation", domainId: "ProductAllocationMethod"},
                {fieldName: "ACCRUAL_METRIC_METHOD", realName: "Accrual Metric Method", domainId:"AccrualMetricMethod"},
                {fieldName: "CUSTOMER_OUTPUT_LEVEL", realName: "Customer Output Level", domainId: "Customer_Type"},
                {fieldName: "CUSTOMER_ALLOCATION_METHOD", realName: "Customer Allocation Method", domainId: "CustomerAllocationMethod"},
                {fieldName: "COST_RECOGNITION_DATES", realName: "Cost Recognition Dates",domainId: "CostRecognitionDates"},
                {fieldName: "TIME_ALLOCATION_METHOD", realName: "Time Allocation", domainId: "TimeAllocationMethod"},
                {fieldName: "PAYMENT_METHOD",         realName: "Payment Method", domainId: "PaymentMethod"},
                {fieldName: "GL_EXPENSETYPE_ID",      realName: "Expense Type", domainId: "Expense_Type"},
                {fieldName: "EVALUATION_ORDER",       realName: "Evaluation Order"},
                {fieldName: "GLRULE_SUBSET_ID",       realName: "GL Rule Subset", domainId: "GLRule_Subset"},
                {fieldName: "RATE_BASIS_ID",          realName: "Rate Basis", domainId: "RateBasis"},
                {fieldName: "EFFECTIVE_START_DT",     realName: "Effective Start Date"},
                {fieldName: "EFFECTIVE_END_DT",       realName: "Effective End Date"},
                {fieldName: "WB_PRDH_ID",             realName: "Product Hierarchy",  ...auditFieldFK.productHierarchy },
                {fieldName: "WB_CUSTH_ID",            realName: "Customer Hierarchy", ...auditFieldFK.customerHierarchy },
                {fieldName: "WB_CUST_ID",             realName: "Customer",           ...auditFieldFK.customer },
                {fieldName: "WB_EVTSTYPE_ID",         realName: "Event Spend Type",   ...auditFieldFK.eventSpendType},
                {fieldName: "WB_SPENDM_ID",           realName: "Spend Method",       ...auditFieldFK.spendType },
                {fieldName: "WB_PRDGRP_ID",           realName: "Product Group",      ...auditFieldFK.productGroup},
                {fieldName: "WB_FUNDTYPE_ID",         realName: "Fund Type",          ...auditFieldFK.fundType },
                {fieldName: "USE_RULE_GLACCT_IND",    realName: "Use Rule GL Account Assignments",  booleanIndField: true }
            ]

        // Accounts
        const generalLedgerPolicyAccountParams: IAuditField [] = [
            {fieldName: "WB_GLACCT_ID",      realName: "GL Account",   bAllMsg: true, ...auditFieldFK.glAccount },
            {fieldName: "WB_FUNDTYPE_ID",    realName: "Fund Type",    bAllMsg: true, ...auditFieldFK.fundType},
            {fieldName: "PAYMENT_METHOD",    realName: "Payment Type", bAllMsg: true, domainId: "PaymentMethod" },
            {fieldName: "GL_EXPENSETYPE_ID", realName: "Expense Type", bAllMsg: true, domainId: "Expense_Type" },
        ]
            await AuditUtils.logRecord(auditService, self.drWB_GeneralLedgerPolicy, generalLedgerPolicyParams)

            // Accounts
            _.forEach(self.drWB_GeneralLedgerPolicy.WB_GeneralLedgerPolicyAccountRows, async (aGenLedPolAcctRow: WB_GeneralLedgerPolicyAccountRow) => {
                await AuditUtils.logRecord(auditService, aGenLedPolAcctRow, generalLedgerPolicyAccountParams, {objectName: 'Account Assignment', deletedKeys: deleteKeys})
            })

            return auditService

    }

}
